import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { schedularTherapistFilterAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* splitTaskMin(action: any): SagaReturnType<any> {
  try {

    yield put({type:schedularTherapistFilterAction.SPLIT_TASK_MIN_LOADING})
    const response = yield call(
      therapistSchedulingServices.getSplitTaskMin,
      action.payload
    );
    if (response?.status === 200) {
      yield put({
        type: schedularTherapistFilterAction.SPLIT_TASK_MIN_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({
      type: schedularTherapistFilterAction.SPLIT_TASK_MIN_FAILURE,
      payload: error,
    });
  }
}

function* splitTaskMinSaga() {
  yield takeEvery(
    schedularTherapistFilterAction.SPLIT_TASK_MIN_REQUEST,
    splitTaskMin
  );
}

export default splitTaskMinSaga;
